import { Button } from "@engaging-tech/components"
import { Link, usePaths } from "@engaging-tech/routing"
import React from "react"
import { useSelector } from "react-redux"
import { useHistory } from "react-router-dom"

import { getSubmissionId } from "../store/survey.selectors"

const PublicResults = ({ t }) => {
  const history = useHistory()
  const paths = usePaths()

  const submissionId = useSelector(getSubmissionId)

  const isInAppView = history.location.pathname.includes("/in-app-view")
  const linkPath = isInAppView
    ? paths.inAppViewOrganisationSurvey.results.replace(":id", submissionId)
    : paths.survey.results.replace(":id", submissionId)

  return (
    <Link to={linkPath}>
      <Button data-testid="survey-continue-btn" variant="primary.0" height={36} px={4}>
        {t("thankyou.continue", "")}
      </Button>
    </Link>
  )
}

export default PublicResults
